import * as React from 'react';
import Loading from '../../Components/Loading/LoadingCenterPage';
import LoadHospital from './LoadData/LoadHospital';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Button, Chip, IconButton } from '@mui/material';
import Swal from 'sweetalert2';
import IMG from '../../IMG/unnamed.jpg'
import NotifyDiscord from '../../Func/NotifyDiscord';
import { 
    ShoppingBagIcon, 
    PlusCircleIcon,
    TrashIcon,
    CurrencyDollarIcon,
    PhotoIcon,
    BuildingOffice2Icon,
    CheckCircleIcon
} from '@heroicons/react/24/outline';

const OrderShirt = () => {

    const dataHospital = LoadHospital()
    const [dataSelectHosptal, setDataSelectHosptal] = React.useState(null);
    const [dataSelectSize, setDataSelectSize] = React.useState(null);
    const [dataSize, setDataSize] = React.useState([]);
    const [onLoad, setOnload] = React.useState(false);

    const handleChangeHospital = (event, newValue) => {
        if (newValue) {
            setDataSelectHosptal(newValue);
        }
    };

    const handleChangeSize = (event, newValue) => {
        if (newValue) {
            setDataSelectSize(newValue);
        }
    };

    const size = [
        { name: "สีชมพู", size: "S", total: 400 },
        { name: "สีชมพู", size: "M", total: 400 },
        { name: "สีชมพู", size: "L", total: 400 },
        { name: "สีชมพู", size: "XL", total: 490 },
        { name: "สีชมพู", size: "2XL", total: 490 },
        { name: "สีชมพู", size: "3XL", total: 490 },
        { name: "สีชมพู", size: "4XL", total: 520 },
        { name: "สีชมพู", size: "5XL", total: 520 },
        { name: "สีชมพู (แขนยาว)", size: "S", total: 550 },
        { name: "สีชมพู (แขนยาว)", size: "M", total: 550 },
        { name: "สีชมพู (แขนยาว)", size: "L", total: 550 },
        { name: "สีชมพู (แขนยาว)", size: "XL", total: 650 },
        { name: "สีชมพู (แขนยาว)", size: "2XL", total: 650 },
        { name: "สีชมพู (แขนยาว)", size: "3XL", total: 650 },
        { name: "สีชมพู (แขนยาว)", size: "4XL", total: 650 },
        { name: "สีชมพู (แขนยาว)", size: "5XL", total: 650 },
        { name: "สีฟ้า", size: "S", total: 400 },
        { name: "สีฟ้า", size: "M", total: 400 },
        { name: "สีฟ้า", size: "L", total: 400 },
        { name: "สีฟ้า", size: "XL", total: 490 },
        { name: "สีฟ้า", size: "2XL", total: 490 },
        { name: "สีฟ้า", size: "3XL", total: 490 },
        { name: "สีฟ้า", size: "4XL", total: 520 },
        { name: "สีฟ้า", size: "5XL", total: 520 },
        { name: "สีฟ้า (แขนยาว)", size: "S", total: 550 },
        { name: "สีฟ้า (แขนยาว)", size: "M", total: 550 },
        { name: "สีฟ้า (แขนยาว)", size: "L", total: 550 },
        { name: "สีฟ้า (แขนยาว)", size: "XL", total: 650 },
        { name: "สีฟ้า (แขนยาว)", size: "2XL", total: 650 },
        { name: "สีฟ้า (แขนยาว)", size: "3XL", total: 650 },
        { name: "สีฟ้า (แขนยาว)", size: "4XL", total: 650 },
        { name: "สีฟ้า (แขนยาว)", size: "5XL", total: 650 },
        { name: "เน็ทผม", size: "", total: 130 },
    ]

    const formatMoney = (value) => {
        const data = new Intl.NumberFormat().format(value)
        return data
    }

    const onSubmitSize = (e) => {
        e.preventDefault();

        const form = document.getElementById("size");
        const formData = new FormData(form);

        const obj_size = {
            hcode: dataSelectHosptal?.hcode,
            hname: dataSelectHosptal?.hname,
            name: formData.get("name"),
            size: formData.get("size"),
            total: formData.get("total"),
            amount: formData.get("amount"),
        };

        setDataSize(prev => [...prev, obj_size]);
        form.reset();
        setDataSelectSize(null);
    };

    const removeItem = (index) => {
        setDataSize(prev => prev.filter((_, i) => i !== index));
    };

    const sum = React.useMemo(() => {
        const sumData = dataSize?.reduce((acc, item) => {
            const totalCost = Number(item.total) * Number(item.amount);
            return acc + totalCost;
        }, 0);

        return sumData;
    }, [dataSize]);

    function generateRandomIdFromHcode(hcode) {
        const now = new Date();
        const dateStr = now.toISOString().split('T')[0].replace(/-/g, '');
        const timeStr = now.toTimeString().split(' ')[0].replace(/:/g, '');
        return `${hcode}_${dateStr}${timeStr}`;
    }

    const handleOnSubmit = () => {

        Swal.fire({
            title: "ยืนยันบันทึก",
            icon: 'warning',
            showDenyButton: true,
            confirmButtonText: "ตกลง",
            denyButtonText: `ยกเลิก`,
            allowOutsideClick: () => {
                const popup = Swal.getPopup();
                popup.classList.remove('swal2-show');
                setTimeout(() => {
                    popup.classList.add('animate__animated', 'animate__headShake');
                }, 0);
                setTimeout(() => {
                    popup.classList.remove('animate__animated', 'animate__headShake');
                }, 500);
                return false;
            },
        }).then((result) => {
            if (result.isConfirmed) {

                setOnload(true)

                const imageInput = document.getElementById("fileInput");
                const file = imageInput?.files[0];

                if (dataSize?.length === 0) {
                    Swal.fire("ไม่พบรายการสั่งซื้อ", "", "error");
                    setOnload(false)
                    return
                }

                if (file === undefined) {
                    Swal.fire("ไม่พบสลิปโอนเงิน", "", "error");
                    setOnload(false)
                    return
                }

                if (file) {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        const base64Image = reader.result.split(",")[1];
                        const imageType = file.type;

                        const hcode = dataSize?.[0]?.hcode || 'UNKNOWN';
                        if (hcode === "UNKNOWN") {
                            Swal.fire("ไม่ได้เลือกสถานพยาบาล", "", "error");
                            setOnload(false)
                            return
                        }
                        const groupId = generateRandomIdFromHcode(hcode);

                        const updatedDataSize = dataSize.map(item => ({
                            ...item,
                            group: groupId,
                        }));

                        const formData = new FormData();
                        formData.append("action", "create");
                        formData.append("data", JSON.stringify(updatedDataSize));
                        formData.append("imageBase64", base64Image);
                        formData.append("imageType", imageType);

                        const base64ToBlob = (base64, mime) => {
                            const byteString = atob(base64);
                            const ab = new ArrayBuffer(byteString.length);
                            const ia = new Uint8Array(ab);
                            for (let i = 0; i < byteString.length; i++) {
                                ia[i] = byteString.charCodeAt(i);
                            }
                            return new Blob([ab], { type: mime });
                        };

                        const blob = base64ToBlob(base64Image, imageType);

                        const DateTH = new Date().toLocaleDateString('th-TH', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                        })

                        const items = JSON.parse(formData.get("data"));
                        let totalSum = 0;

                        const itemText = items.map(item => {
                            const totalPrice = Number(item.total) * Number(item.amount);
                            totalSum += totalPrice;
                            return `- 🔸 ${item.name} (${item.size}) × ${item.amount} ตัว = ${totalPrice.toLocaleString()} บาท`;
                        }).join("\n");
                        const message = `
📥 **มีรายการใหม่**
====================
**สถานพยาบาล** : ${items[0]?.hname}
**วันที่สั่งซื้อ** : ${DateTH}
**รายการ** :
${itemText}

💰 **รวมทั้งหมด: ${totalSum.toLocaleString()} บาท**
====================
`;

                        fetch("https://script.google.com/macros/s/AKfycbzKbLbsjasaPeZ_aLfFCIRsjTonDfEwcCfgIeZHS7HRMhGNz0jfnqsWnscVkzEjL4pHYw/exec", {
                            method: "POST",
                            body: formData,
                        })
                            .then((res) => res.json())
                            .then(async (res) => {

                                await NotifyDiscord("1384753716971700224", "Y9xUI_uBtSeuPQdXB3VAsjc8klCJF61Lu0DKL1pefeGqI6Nmz-jOgk3I7lWjuVVoCryR", message, blob)

                                setOnload(false)

                                Swal.fire({
                                    title: "บันทึกข้อมูลสำเร็จ",
                                    icon: 'success',
                                    confirmButtonText: "ตกลง",
                                    allowOutsideClick: () => {
                                        const popup = Swal.getPopup();
                                        popup.classList.remove('swal2-show');
                                        setTimeout(() => {
                                            popup.classList.add('animate__animated', 'animate__headShake');
                                        }, 0);
                                        setTimeout(() => {
                                            popup.classList.remove('animate__animated', 'animate__headShake');
                                        }, 500);
                                        return false;
                                    },
                                }).then((result) => {

                                    if (result.isConfirmed) {

                                        window.location.replace("https://ratchaphruek-hemodialysis.web.app/")

                                    }

                                })

                            })
                            .catch((err) => {
                                console.error("เกิดข้อผิดพลาด:", err);
                                Swal.fire("ผิดพลาด", "ไม่สามารถบันทึกได้", "error");
                                setOnload(false)
                            });
                    };

                    reader.readAsDataURL(file);
                }
            }
        });
        
    };

    return (
        <>
            {!!dataHospital ? (
                <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 md:p-8">
                    <div className="max-w-6xl mx-auto">
                        
                        {/* Header Section */}
                        <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-6 md:p-8 mb-6">
                            <div className="flex items-center gap-4 mb-4">
                                <div className="p-3 bg-gradient-to-br from-pink-500 to-pink-600 rounded-2xl shadow-lg">
                                    <ShoppingBagIcon className="h-8 w-8 text-white" />
                                </div>
                                <div>
                                    <h1 className="text-3xl font-black text-gray-900 tracking-tight">สั่งซื้อเสื้อพนักงาน</h1>
                                    <p className="text-sm text-gray-500 mt-1">เครือราชพฤกษ์ไตเทียม</p>
                                </div>
                            </div>

                            {/* Bank Info */}
                            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-4 border border-blue-200">
                                <div className="flex items-start gap-3">
                                    <CurrencyDollarIcon className="h-6 w-6 text-blue-600 flex-shrink-0 mt-1" />
                                    <div>
                                        <p className="text-sm font-bold text-blue-900 mb-1">ข้อมูลการโอนเงิน</p>
                                        <p className="text-sm text-blue-700">
                                            <span className="font-semibold">ธนาคารกรุงไทย</span> | 
                                            บัญชีเลขที่ <span className="font-mono font-bold">014-02147-47</span> | 
                                            บจ.เพื่อนพลพลอย
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Shirt Image */}
                        <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-6 mb-6">
                            <h2 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                                <PhotoIcon className="h-5 w-5 text-gray-600" />
                                ตัวอย่างเสื้อ
                            </h2>
                            <img src={IMG} alt="Shirt Example" className="w-full max-w-2xl mx-auto rounded-2xl shadow-md" />
                        </div>

                        {/* Hospital Selection */}
                        <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-6 mb-6">
                            <h2 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                                <BuildingOffice2Icon className="h-5 w-5 text-gray-600" />
                                เลือกสถานพยาบาล
                            </h2>
                            <Autocomplete
                                disablePortal
                                options={dataHospital}
                                getOptionLabel={(option) => option?.hname}
                                value={dataSelectHosptal}
                                onChange={handleChangeHospital}
                                renderInput={(params) => (
                                    <TextField 
                                        {...params} 
                                        label="สถานพยาบาล" 
                                        required
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                '&:hover fieldset': { borderColor: '#4F46E5' },
                                            }
                                        }}
                                    />
                                )}
                            />
                            {dataSelectHosptal && (
                                <Chip 
                                    label={`เลือก: ${dataSelectHosptal.hname}`}
                                    sx={{ mt: 2, bgcolor: '#DBEAFE', color: '#1E40AF', fontWeight: 700 }}
                                />
                            )}
                        </div>

                        {/* Add Item Form */}
                        <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-6 mb-6">
                            <h2 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                                <PlusCircleIcon className="h-5 w-5 text-gray-600" />
                                เพิ่มรายการสินค้า
                            </h2>
                            <form id="size" onSubmit={onSubmitSize} className="space-y-4">
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                    <div className="md:col-span-2">
                                        <Autocomplete
                                            disablePortal
                                            options={size}
                                            getOptionLabel={(option) => `${option.name} ${option.size || ""} - ${option.total} บาท`}
                                            value={dataSelectSize}
                                            onChange={handleChangeSize}
                                            renderInput={(params) => (
                                                <TextField 
                                                    {...params} 
                                                    label="เลือกไซส์และสีเสื้อ" 
                                                    required
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            '&:hover fieldset': { borderColor: '#4F46E5' },
                                                        }
                                                    }}
                                                />
                                            )}
                                        />
                                        <TextField style={{ display: 'none' }} name='size' value={dataSelectSize?.size || ''} />
                                        <TextField style={{ display: 'none' }} name='name' value={dataSelectSize?.name || ''} />
                                        <TextField style={{ display: 'none' }} name='total' value={dataSelectSize?.total || ''} />
                                    </div>
                                    <TextField 
                                        required 
                                        name='amount' 
                                        type='number' 
                                        label="จำนวน (ชิ้น)" 
                                        variant="outlined"
                                        inputProps={{ min: 1 }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                '&:hover fieldset': { borderColor: '#4F46E5' },
                                            }
                                        }}
                                    />
                                </div>
                                <Button 
                                    type='submit' 
                                    variant="contained"
                                    startIcon={<PlusCircleIcon style={{ width: 20 }} />}
                                    sx={{ 
                                        borderRadius: 2, 
                                        px: 4, 
                                        py: 1.5, 
                                        bgcolor: '#6366F1', 
                                        textTransform: 'none', 
                                        fontWeight: 700,
                                        '&:hover': { bgcolor: '#4F46E5' }
                                    }}
                                >
                                    เพิ่มรายการ
                                </Button>
                            </form>
                        </div>

                        {/* Order List */}
                        {dataSize.length > 0 && (
                            <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-6 mb-6">
                                <h2 className="text-lg font-bold text-gray-900 mb-4">รายการสั่งซื้อ</h2>
                                <div className="space-y-3">
                                    {dataSize.map((v, i) => (
                                        <div key={i} className="flex items-center justify-between p-4 bg-gray-50 rounded-xl border border-gray-200">
                                            <div className="flex items-start gap-3 flex-1">
                                                <span className="flex-shrink-0 w-8 h-8 bg-indigo-100 text-indigo-700 rounded-full flex items-center justify-center text-sm font-bold">
                                                    {i + 1}
                                                </span>
                                                <div className="flex-1">
                                                    <p className="text-sm font-bold text-gray-900">
                                                        {v.name} {v.size && `(${v.size})`}
                                                    </p>
                                                    <p className="text-xs text-gray-600 mt-1">
                                                        จำนวน <span className="font-bold">{v.amount}</span> ชิ้น × 
                                                        <span className="font-bold"> {v.total}</span> บาท = 
                                                        <span className="font-bold text-indigo-600"> {formatMoney(Number(v.total) * Number(v.amount))}</span> บาท
                                                    </p>
                                                </div>
                                            </div>
                                            <IconButton 
                                                onClick={() => removeItem(i)}
                                                sx={{ bgcolor: '#FEF2F2', '&:hover': { bgcolor: '#FEE2E2' } }}
                                                size="small"
                                            >
                                                <TrashIcon className="h-5 w-5 text-red-600" />
                                            </IconButton>
                                        </div>
                                    ))}
                                </div>
                                
                                {/* Total */}
                                <div className="mt-4 p-4 bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl border border-green-200">
                                    <p className="text-lg font-bold text-green-700 flex items-center justify-between">
                                        <span className="flex items-center gap-2">
                                            <CurrencyDollarIcon className="h-6 w-6" />
                                            รวมยอดเงินที่ต้องโอน
                                        </span>
                                        <span className="text-2xl text-green-900">{formatMoney(sum || 0)} บาท</span>
                                    </p>
                                </div>
                            </div>
                        )}

                        {/* Upload Slip */}
                        <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-6 mb-6">
                            <h2 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                                <PhotoIcon className="h-5 w-5 text-gray-600" />
                                แนบสลิปโอนเงิน
                            </h2>
                            <div className="border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center hover:border-indigo-400 transition-colors">
                                <input 
                                    type="file" 
                                    required 
                                    id="fileInput" 
                                    accept="image/*"
                                    className="block w-full text-sm text-gray-500 file:mr-4 file:py-3 file:px-6 file:rounded-xl file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100 cursor-pointer"
                                />
                                <p className="text-xs text-gray-500 mt-2">รองรับไฟล์ภาพทุกประเภท</p>
                            </div>
                        </div>

                        {/* Submit Button */}
                        {!onLoad ? (
                            <Button 
                                onClick={handleOnSubmit} 
                                variant="contained"
                                fullWidth
                                startIcon={<CheckCircleIcon style={{ width: 24 }} />}
                                sx={{ 
                                    borderRadius: 3, 
                                    py: 2, 
                                    bgcolor: '#10B981', 
                                    textTransform: 'none', 
                                    fontWeight: 700,
                                    fontSize: 16,
                                    boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
                                    '&:hover': { bgcolor: '#059669' }
                                }}
                            >
                                ยืนยันการสั่งซื้อ
                            </Button>
                        ) : (
                            <div className="flex justify-center py-8">
                                <div className="flex space-x-2">
                                    <div className="w-3 h-3 bg-green-600 rounded-full animate-bounce"></div>
                                    <div className="w-3 h-3 bg-green-600 rounded-full animate-bounce [animation-delay:-.3s]"></div>
                                    <div className="w-3 h-3 bg-green-600 rounded-full animate-bounce [animation-delay:-.5s]"></div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                <Loading />
            )}
        </>
    )
}

export default OrderShirt
